export default __webpack_public_path__ + "static/media/queue_seat_increase.e6f91bd6.svg";